import type { ReactNode } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import type { ContactMetier, CreateContactMetierDto } from "models";
import { getPlural } from "utils";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { ContactMetierResume } from "components/ContactMetierResume";

interface SimilarCreationConfirmationDialogProps {
  contactMetierToCreate?: CreateContactMetierDto;
  similarContactsMetiers?: Array<ContactMetier>;
  onConfirm?: () => void;
  onClose: () => void;
  isOpen: boolean;
}

export function SimilarCreationConfirmationDialog({
  contactMetierToCreate,
  similarContactsMetiers,
  onConfirm,
  onClose,
  isOpen,
}: Readonly<SimilarCreationConfirmationDialogProps>): ReactNode {
  const similarCmsNumber = similarContactsMetiers?.length ?? 0;

  if (contactMetierToCreate == null || similarContactsMetiers == null) {
    return;
  }

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Confirmation requise</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Grid container spacing={2}>
            <Typography>
              {getPlural(similarCmsNumber, "Plusieurs", "Un")} Contact{getPlural(similarCmsNumber)}{" "}
              Métier
              {getPlural(similarCmsNumber)} existe{getPlural(similarCmsNumber, "nt")} déjà avec des
              informations similaires :
            </Typography>
            <Grid container spacing={1}>
              {similarContactsMetiers.map((cm) => (
                <ContactMetierResume key={cm.id} contactMetier={cm} />
              ))}
            </Grid>
            <Typography sx={{ fontWeight: "bold" }}>
              Êtes-vous sûr de vouloir créer le Contact Métier suivant ?
            </Typography>
            <ContactMetierResume contactMetier={contactMetierToCreate as ContactMetier} />
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Annuler
        </Button>
        <Button
          onClick={() => {
            onConfirm?.();
            onClose();
          }}
          variant="contained"
          autoFocus
          loadingPosition="start"
          startIcon={<PersonAddAlt1Icon />}>
          Créer le Contact Métier
        </Button>
      </DialogActions>
    </Dialog>
  );
}
